import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 20px 0 0;

  & > .list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
`;
